import { ENGLISH, getI18nText, isI18nEnabled, isBrowserNorwegianLanguage, NORWEGIAN } from './project-i18n-model';
import { useProject } from '../project-hooks/useProject';

const I18nText = ({ textKey, variables, lowerCase }) => {
    const project = useProject();
    const languageKey = isI18nEnabled(project) ? (isBrowserNorwegianLanguage() ? NORWEGIAN : ENGLISH) : NORWEGIAN;
    return getI18nText({ languageKey, textKey, variables, lowerCase });
};

export default I18nText;
